import * as styles from './system-tag.css.ts'

type SystemTagProps = {
  /** Where the item is managed instead, shown on hover. */
  title?: string
}

/** Marks something the deployment's own configuration owns, so it cannot be edited in the product. */
export const SystemTag: React.FC<SystemTagProps> = ({ title }) => (
  <span className={styles.systemTag} title={title}>
    System
  </span>
)
